/**
 * PubNub timetokens exceed Number.MAX_SAFE_INTEGER. Always normalize to string
 * as early as possible so delete/history operations use the exact token value.
 */
export function normalizePubNubTimetoken(
  value: string | number | undefined | null,
): string {
  if (value == null) return '';
  if (typeof value === 'string') return value.trim();
  if (!Number.isSafeInteger(value)) {
    return value.toLocaleString('fullwide', {
      useGrouping: false,
      maximumFractionDigits: 0,
    });
  }

  return String(value);
}
